import styled from '@emotion/styled'

import { Flex } from '../layout/Flex'

interface ModalPaneHeaderProps {
  children?: React.ReactNode
  justifyContent?: 'start' | 'end'
}

const ModalPaneHeaderContainer = styled(Flex)`
  background: ${props => props.theme.arcadeColors.component.modalBackground};
  height: 5.5rem;
  box-shadow: ${props => props.theme.dropShadows.topBar};
  width: 100%;

  ${props => props.theme.breakpoints.tablet} {
    border-top: ${({ theme }) => `${theme.pxToRem(1)}`} solid ${({ theme }) => theme.arcadeColors.semantic.borderSubtle};
    border-bottom: ${({ theme }) => `${theme.pxToRem(1)}`} solid
      ${({ theme }) => theme.arcadeColors.semantic.borderSubtle};
  }
`

const ArcadeModalPaneHeader = ({ children, justifyContent = 'end' }: ModalPaneHeaderProps) => (
  <ModalPaneHeaderContainer alignItems="center" justifyContent={justifyContent}>
    {children}
  </ModalPaneHeaderContainer>
)

export default ArcadeModalPaneHeader
